/** Labels for the Serviços mega dropdown (aligned with site locales). */
const pt = {
  panelCta: 'Painel',
  webDev: 'Desenvolvimento Web',
  ecommerce: 'E-commerce',
  marketing: 'Marketing Digital',
  automation: 'Automação',
  mobile: 'Aplicativos Mobile',
  consulting: 'Consultoria em TI',
  wsjPedidos: 'WSJ Pedidos',
  digitalMenu: 'Cardápio Digital',
  digitalInvites: 'Convites Digitais',
  urbanTransport: 'Transporte Urbano em Tempo Real',
  ambassadors: 'Indique e Ganhe'
};

const en = {
  panelCta: 'Dashboard',
  webDev: 'Web development',
  ecommerce: 'E-commerce',
  marketing: 'Digital marketing',
  automation: 'Automation',
  mobile: 'Mobile apps',
  consulting: 'IT consulting',
  wsjPedidos: 'WSJ Pedidos',
  digitalMenu: 'Digital menu',
  digitalInvites: 'Digital invitations',
  urbanTransport: 'Real-time urban transport',
  ambassadors: 'Refer & earn'
};

export const navServicesLabels = {
  'pt-BR': pt,
  'pt-PT': pt,
  en,
  es: {
    panelCta: 'Panel',
    webDev: 'Desarrollo web',
    ecommerce: 'E-commerce',
    marketing: 'Marketing digital',
    automation: 'Automatización',
    mobile: 'Apps móviles',
    consulting: 'Consultoría TI',
    wsjPedidos: 'WSJ Pedidos',
    digitalMenu: 'Menú digital',
    digitalInvites: 'Invitaciones digitales',
    urbanTransport: 'Transporte urbano en tiempo real',
    ambassadors: 'Recomienda y gana'
  },
  fr: {
    panelCta: 'Tableau',
    webDev: 'Développement web',
    ecommerce: 'E-commerce',
    marketing: 'Marketing digital',
    automation: 'Automatisation',
    mobile: 'Applications mobiles',
    consulting: 'Conseil en IT',
    wsjPedidos: 'WSJ Pedidos',
    digitalMenu: 'Menu numérique',
    digitalInvites: 'Invitations numériques',
    urbanTransport: 'Transport urbain en temps réel',
    ambassadors: 'Parrainez et gagnez'
  },
  it: {
    panelCta: 'Pannello',
    webDev: 'Sviluppo web',
    ecommerce: 'E-commerce',
    marketing: 'Marketing digitale',
    automation: 'Automazione',
    mobile: 'App mobile',
    consulting: 'Consulenza IT',
    wsjPedidos: 'WSJ Pedidos',
    digitalMenu: 'Menu digitale',
    digitalInvites: 'Inviti digitali',
    urbanTransport: 'Trasporto urbano in tempo reale',
    ambassadors: 'Invita e guadagna'
  },
  hi: en,
  de: en,
  nl: en,
  ru: en,
  ar: en,
  'zh-CN': en,
  'zh-TW': en
};
